import { useCallback, useContext } from 'react';
import { SectionContext } from '../../../context/SectionContext';
import SizeRestrictedButton from '../SizeRestrictedButton';
import { jsx as _jsx } from "react/jsx-runtime";
const ChatspotActionButtonV2 = ({
  chatspotActionButton,
  inDataTable,
  size,
  eventName,
  eventProperties,
  usageTracker,
  usageTrackerLocation,
  disabled,
  tooltip,
  use = 'tertiary'
}) => {
  const {
    isWaitingForChatResponse,
    onCopilotActionV2Clicked
  } = useContext(SectionContext);
  const onClick = useCallback(() => {
    onCopilotActionV2Clicked(chatspotActionButton, {
      inDataTable
    });
  }, [chatspotActionButton, inDataTable, onCopilotActionV2Clicked]);

  // If eventName and eventProperties are provided, use SizeRestrictedButton with tracking
  if (usageTracker && usageTrackerLocation && eventName && eventProperties) {
    return /*#__PURE__*/_jsx(SizeRestrictedButton, {
      disabled: isWaitingForChatResponse || !!chatspotActionButton.isDisabled || disabled,
      onClick: onClick,
      size: size,
      truncate: true,
      use: use,
      eventName: eventName,
      eventProperties: eventProperties,
      usageTracker: usageTracker,
      usageTrackerLocation: usageTrackerLocation,
      tooltip: tooltip,
      children: chatspotActionButton.label
    });
  }
  return /*#__PURE__*/_jsx(SizeRestrictedButton, {
    disabled: isWaitingForChatResponse || !!chatspotActionButton.isDisabled || disabled,
    onClick: onClick,
    size: size,
    truncate: true,
    use: use,
    tooltip: tooltip,
    children: chatspotActionButton.label
  });
};
export default ChatspotActionButtonV2;